<template>
    <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">Voicemails</h4>
        <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                <base-input v-model="searchQuery" class="search-input mb-3" addon-left-icon="fal fa-search"
                            style="max-width: 200px;">
                </base-input>
            </div>
            <v-data-table id="voicemailsTable"
                          :headers="headers" :search="searchQuery"
                          :items="voicemails" :loading="isLoadingVoicemails"
                          item-key="invoiceID" :pagination.sync="paginationSync"
                          :rows-per-page-items="rowsperpageitems"
                          show-summary data-app
            >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>{{ moment.unix(props.item.timestamp).tz(timezone).format('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td>{{ props.item.callerid }}</td>
                        <td>{{ moment.duration(parseInt(props.item.duration), "seconds").format("h:mm:ss", {
                            trim: false
                            }) }}
                        </td>
                        <td>
                            <badge type="primary">{{ props.item.voicemail }}</badge>
                        </td>
                        <td>
                            <vue-plyr
                                :options="{'controls': [ 'play','progress', 'current-time', 'mute']}"
                                style="display: inline-block;">
                                <audio preload="none">
                                    <source :src="baseURL + props.item.links.recording" type="audio/wav"/>
                                </audio>
                            </vue-plyr>

                            <base-button
                                @click.native="removeVoiceMessage(props.index, props.item, $event)"
                                class="like btn-link right"
                                type="danger"
                                size="sm"
                                icon
                                :loading="loading[props.index]"
                            >
                                <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
                            </base-button>
                            <a
                                :href="baseURL + props.item.links.recording"
                                class="like btn-link right btn-info"
                                type="info"
                                size="sm"
                            >
                                <font-awesome-icon :icon="['fal','download']"></font-awesome-icon>
                            </a>

                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </card>
</template>

<script>
    import {BasePagination} from 'src/components';
    import Fuse from 'fuse.js';
    import * as axios from "axios";
    import Badge from "../../components/Badge";
    import swal from 'sweetalert2';

    export default {
        name: "VoicemailsTable",
        components: {
            BasePagination,
            Badge,

        },
        computed: {
            voicemails() {
                return this.$store.getters['voicemail/voiceMessages'];
            },
            isLoadingVoicemails() {
                return this.$store.getters['voicemail/isLoading'];
            },
            timezone() {
                return this.$store.getters['customer/timezone'].timezone;
            }
        },
        data() {
            return {
                rowsperpageitems:
                    [5, 10, 25, 50, 100, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],

                paginationSync: {
                    rowsPerPage: 10,
                    descending: true,
                    sortBy: 'id',
                },
                searchQuery: '',
                voiceMessageRecording: null,
                searchedData: [],
                fuseSearch: null,
                loading: [],
                headers: [
                    {text: 'ID', align: 'left', sortable: true, value: 'id'},
                    {text: 'Caller ID', value: 'callerid', sortable: false,},
                    {text: 'Duration', value: 'duration', sortable: true,},
                    {text: 'Voicemail', value: 'voicemail', sortable: false,},
                    {text: 'Actions', align: 'right'},
                ],
            };
        },
        methods: {
            playRecording(index, item, $event) {
                let audio = this.baseURL + this.voicemails[index].links.recording;
                let audioElement = this.$refs['audio-' + index];
                audioElement.src = audio;
                audioElement.play();
            },
            removeVoiceMessage(index, item, $event) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('voicemail/deleteVoiceMessage', item).then(() => {
                            this.$store.dispatch('voicemail/loadVoicemailMessages').then(() => {
                            });

                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your voicemail was removed!',
                                type: "success",
                                icon: "fal fa-trash",
                                title: "Removed!"
                            });
                        });

                    }
                })
            },
            stopRecording(index, item, $event) {
                this.$refs['audio-' + index].pause();
                // audioElement.pause();
            },
            downloadRecording(index, item, $event) {
                let audio = this.baseURL + this.voicemails[index].links.recording;

                axios({
                    url: audio,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "voicemessage-" + item.id + '.wav'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },
        },
        mounted() {
            if (this.$store.getters['voicemail/messagesNeedUpdate']) {
                this.$store.dispatch('voicemail/loadVoicemailMessages');
            }

            // Fuse search initialization.
            this.fuseSearch = new Fuse(this.voicemails, {
                keys: ['id', 'callerid', 'duration', 'timestamp'],
                threshold: 0.3
            });

        },
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }
</style>
